var map = {
	"./en/4-1/tit.png": 11852,
	"./fi/4-1/tit.png": 8994,
	"./in/4-1/tit.png": 6480,
	"./th/4-1/tit.png": 18433,
	"./tw/4-1/tit.png": 69470,
	"./zh/4-1/tit.png": 23127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44962;